var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRho(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.432 0.431999C3.552 0.431999 4.368 0.651999 4.88 1.092C5.392 1.532 5.648 2.152 5.648 2.952C5.648 3.304 5.588 3.644 5.468 3.972C5.356 4.292 5.168 4.58 4.904 4.836C4.64 5.092 4.288 5.296 3.848 5.448C3.408 5.592 2.868 5.664 2.228 5.664H1.244V9H0.164V0.431999H2.432ZM2.336 1.356H1.244V4.74H2.108C2.652 4.74 3.104 4.684 3.464 4.572C3.824 4.452 4.092 4.264 4.268 4.008C4.444 3.752 4.532 3.416 4.532 3C4.532 2.448 4.356 2.036 4.004 1.764C3.652 1.492 3.096 1.356 2.336 1.356Z",
    fill: "white",
    fillOpacity: 0.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRho);
export default __webpack_public_path__ + "static/media/rho.6845eec2ccd0de86a34ecc2d1afc0e50.svg";
export { ForwardRef as ReactComponent };